export default "__VITE_ASSET__DKfBA4em__"